import React from 'react'

function PenIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
    >
      <g filter="url(#filter0_d_2931_1465)">
        <path
          d="M11.4946 4.00195C11.8758 3.86547 12.2993 3.88834 12.6665 4.07031L12.7544 4.11914C12.957 4.24276 13.1405 4.43295 13.354 4.64648L13.689 4.99219C13.7877 5.10365 13.8709 5.21446 13.9302 5.33398L13.9985 5.49414C14.1156 5.821 14.1156 6.179 13.9985 6.50586L13.9302 6.66602C13.8709 6.78554 13.7877 6.89635 13.689 7.00781L13.354 7.35352L8.74561 11.9619C8.61373 12.0938 8.49588 12.2146 8.36475 12.3125L8.22803 12.4023C8.13261 12.4564 8.03214 12.4961 7.92529 12.5293L7.58447 12.6191L6.26318 12.9492C6.09899 12.9903 5.92051 13.0362 5.77197 13.0508C5.61728 13.0659 5.35636 13.0628 5.14697 12.8535C4.93771 12.6443 4.93363 12.3833 4.94873 12.2285C4.96325 12.0801 5.00927 11.9014 5.05029 11.7373L5.38037 10.416L5.47119 10.0752C5.50439 9.96829 5.5441 9.86792 5.59814 9.77246L5.68799 9.63574C5.78586 9.50459 5.90668 9.38677 6.03857 9.25488L10.647 4.64648L10.9927 4.31152C11.1041 4.21281 11.215 4.12954 11.3345 4.07031L11.4946 4.00195Z"
          stroke="#393D63"
        />
        <path
          d="M10.3335 5.0013L12.3335 3.66797L14.3335 5.66797L13.0002 7.66797L10.3335 5.0013Z"
          fill="#393D63"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2931_1465"
          x="-2"
          y="0"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2931_1465"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2931_1465"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default PenIcon
